import React from 'react';
import {
  HomeIcon,
  Cog6ToothIcon,
  ArrowRightStartOnRectangleIcon,
  TrashIcon,
  Bars3Icon,
  MegaphoneIcon,
  ThemeIcon,
  ArrowsPointingOutIcon,
  DocumentTextIcon,
  CalendarIcon,
  MoonIcon,
} from '../Icons/Icons';
import { SpotlightItem, SpotlightIconType } from './spotlight.types';

const iconComponents: Record<SpotlightIconType, React.FC<{ className?: string }>> = {
  home: HomeIcon,
  settings: Cog6ToothIcon,
  logout: ArrowRightStartOnRectangleIcon,
  cache: TrashIcon,
  menu: Bars3Icon,
  theme: ThemeIcon,
  'release-notes': MegaphoneIcon,
  focus: ArrowsPointingOutIcon,
  'night-mode': MoonIcon,
  notes: DocumentTextIcon,
  calendar: CalendarIcon,
};

interface SpotlightIconProps {
  item: SpotlightItem;
  className?: string;
}

export const SpotlightIcon: React.FC<SpotlightIconProps> = ({ item, className = 'neo-spotlight-home-icon' }) => {
  // If item has a specific icon type
  if (item.icon) {
    // Special case for menu items with custom icons
    if (item.icon === 'menu' && item.menuIcon) {
      return <img src={item.menuIcon} alt="" className="neo-spotlight-menu-icon" />;
    }

    const IconComponent = iconComponents[item.icon];
    if (IconComponent) {
      return <IconComponent className={className} />;
    }
  }

  // If item has an image source
  if (item.imgSource) {
    return <img src={item.imgSource} alt="" />;
  }

  // Fallback: show first letter as placeholder
  return (
    <div className="neo-spotlight-result-icon-placeholder">
      {item.title.charAt(0).toUpperCase()}
    </div>
  );
};
